import React from 'react'
import classNames from 'classnames'

interface ConfirmModalProps {
  title: string
  message: string
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  confirmText?: string
  cancelText?: string
}

const ConfirmModal = (props: ConfirmModalProps) => {
  const {
    title,
    message,
    isOpen,
    onConfirm,
    onCancel,
    confirmText,
    cancelText
  } = props
  return (
    <div
      className={classNames({
        modal: true,
        'modal-open': isOpen
      })}
    >
      <div className="modal-box p-8">
        <h1 className="modal-header">{title}</h1>
        <p>{message}</p>
        <div className="modal-action">
          <button className="btn btn-ghost" onClick={e => onCancel()}>
            {cancelText ? cancelText : 'Cancel'}
          </button>
          <button className="btn btn-primary" onClick={e => onConfirm()}>
            {confirmText ? confirmText : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
